export default __webpack_public_path__ + "static/media/people3.ff197b6a.png";